var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "seu-main-header overline"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "asset-container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo/seu-logo.svg"),
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "menu-item-container"
  }, _vm._l(_vm.navigationMenuItems, function (menuItem) {
    return _c('menu-item', {
      key: menuItem.label,
      attrs: {
        "label": menuItem[_vm.currentLanguage].label,
        "route": menuItem.route,
        "params": {
          slug: menuItem[_vm.currentLanguage].slug
        }
      }
    });
  }), 1), _c('language-picker')], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }